module.exports = __webpack_public_path__ + "img/kd-logo-white-big.932b061e.svg";